import React, { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useGetQuery } from '../../../Utils/api';
import { ModeleCourriel } from '../../../../../common/src/entities/modele-courriel.entity';
import FormulaireModificationEntite from '../Utils/FormulaireModificationEntite';
import LogsLoader, { dateFormatter } from '../Utils/Log';
import { Col, Form, Row } from 'react-bootstrap';
import { MyPaper } from '../Utils/MyPaper';
import { HistoriqueLogs } from '../../../../../common/src/entities/historique-logs.entity';
import { useFormikContext } from 'formik';
import RichTextEditor from '../../Common/RichTextEditor';
import LegendeCourriel from './LegendeCourriel';

export const ChampsModeleCourriel: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<ModeleCourriel>();

  const handleEditorChange = (value: string) => {
    setFieldValue('body', value);
  };

  useEffect(() => {
    if (values.body) {
      const cleanedBody = values.body.replace(/\\/g, '');
      setFieldValue('body', cleanedBody);
    }
  }, []);

  return (
    <Row className="mt-4">
      <Col md={8}>
        <Form.Group controlId="name">
          <Form.Label>Nom</Form.Label>
          <Form.Control
            type="text"
            name="name"
            placeholder="Entrez le nom"
            value={values.name || ''}
            onChange={(e) => setFieldValue('name', e.target.value)}
          />
        </Form.Group>

        <Form.Group controlId="title">
          <Form.Label>Titre</Form.Label>
          <Form.Control
            type="text"
            name="title"
            placeholder="Entrez le titre"
            value={values.title || ''}
            onChange={(e) => setFieldValue('title', e.target.value)}
          />
        </Form.Group>

        <Form.Group controlId="body">
          <Form.Label>Contenu</Form.Label>
          <RichTextEditor value={values.body || ''} onChange={handleEditorChange} />
        </Form.Group>
      </Col>
      
      <Col md={4}>
        <LegendeCourriel />
      </Col>
    </Row>
  );
};

export default function DetailsModeleCourriel(): ReactElement {
  const { id } = useParams() as { id: string };
  const listLogs = useGetQuery<HistoriqueLogs[]>(`historique_logs/${id}/modeles_courriel`);

  return (
    <div>
      <FormulaireModificationEntite
        id={+id}
        entite={ModeleCourriel}
        badges={(c: ModeleCourriel) => [
          `Modèle Courriel #${c.id}`,
          `Dernière modification: ${
            listLogs.data?.[listLogs.data.length - 1]?.date_modification
              ? dateFormatter(listLogs.data?.[listLogs.data.length - 1]?.date_modification)
              : 'Aucune modification'
          } par ${listLogs.data?.[listLogs.data.length - 1]?.nom_usager ?? ''}`,
        ]}
      >
        <MyPaper>
          <ChampsModeleCourriel />
        </MyPaper>
      </FormulaireModificationEntite>

      <LogsLoader id={id} tableName="modeles_courriel" />
    </div>
  );
}
